import * as yup from 'yup';
import { API_DATE_FORMAT } from '@domain/_screens/overview/segmented/constants';
import { format, addDays } from '@shared/wrappers/date/date';

export const validateHotSpot = async (selectedHotSpot) => {
    const { endDate, startDate } = selectedHotSpot;
    const startFormat = format(startDate, API_DATE_FORMAT);
    const endFormat = format(addDays(endDate, 1), API_DATE_FORMAT);

    const schema = yup.object().shape({
        endDate: yup.date().min(startFormat).nullable(true),
        selectedCategories: yup.array().min(1),
        startDate: endDate ? yup.date().max(endFormat) : yup.date(),
        title: yup.string().required(),
    });

    try {
        await schema.validate(selectedHotSpot, { abortEarly: false });
        return [];
    } catch (err) {
        const fieldsWithError = err.inner.map(field => field.path);

        return fieldsWithError;
    }
};

export const formatHotSpotToApi = (hotSpot, customerType, customerId) => {
    const {
        endDate,
        startDate,
        selectedCategories,
    } = hotSpot;
    return {
        ...hotSpot,
        end_date: endDate ? format(endDate, API_DATE_FORMAT) : '',
        categories: selectedCategories.map(({ label }) => label).join(','),
        [`${customerType}_id`]: customerId,
        [customerType]: customerId,
        start_date: format(startDate, API_DATE_FORMAT),
    };
};
